function isObject(item) {
	return !!item && typeof item === "object" && !Array.isArray(item);
}

function deepMerge(target, ...sources) {
	if (!sources.length) return target;
	const source = sources.shift();

	if (isObject(target) && isObject(source)) {
		for (const key in source) {
			if (isObject(source[key])) {
				if (!target[key]) Object.assign(target, { [key]: {} });
				deepMerge(target[key], source[key]);
			} else {
				Object.assign(target, { [key]: source[key] });
			}
		}
	}
	return deepMerge(target, ...sources);
}

const activeItems = (state = [], action) => {
	switch (action.type) {
		case "INITIAL_ALERTS_RECEIVED": {
			const ids = [];
			action.alerts.forEach(item => {
				if (item) {
					ids.push(item.id);
				}
			});
			const newState = [...ids];
			return newState;
		}

		case "ALERT_BATCH_RECEIVED": {
			const newState = [...state];
			action.alerts.forEach(item => {
				if (item) {
					if (item.closed) {
						const idx = newState.indexOf(item.id);
						if (idx > -1) newState.splice(idx, 1);
					} else {
						if (!newState.includes(item.id)) newState.push(item.id);
					}
				}
			});
			return newState;
		}

		case "CLOSE_ALERT": {
			let newState = state.slice();
			newState = newState.filter(id => id !== action.alertId);
			return newState;
		}

		case "CLOSE_ALERTS": {
			const closedIds = action.alerts.map(a => a.id);
			let newState = state.slice();
			newState = newState.filter(id => !closedIds.includes(id));
			return newState;
		}

		case "RESTORE_ALERTS": {
			const newState = [...state];
			action.alerts.forEach(alert => {
				if (alert && !newState.includes(alert.id)) {
					newState.push(alert.id);
				}
			});
			return newState;
		}

		default:
			return state;
	}
};

const activeItemsById = (state = {}, action) => {
	switch (action.type) {
		case "INITIAL_ALERTS_RECEIVED": {
			return action.alerts.reduce((acc, not) => {
				if (not) {
					const existing = state[not.id];
					return { ...acc, [not.id]: existing ? deepMerge({}, existing, not) : not };
				} else {
					return { ...acc };
				}
			}, {});
		}

		case "ALERT_BATCH_RECEIVED": {
			const updatedState = { ...state };
			action.alerts.forEach(not => {
				if (not) {
					updatedState[not.id] = state[not.id] ? deepMerge({}, state[not.id], not) : not;
				}
			});
			for (const key of Object.keys(updatedState)) {
				if (updatedState[key].closed) delete updatedState[key];
			}
			return updatedState;
		}

		case "CLOSE_ALERT": {
			const newState = Object.fromEntries(Object.entries(state).filter(([key]) => key !== action.alertId));
			return newState;
		}

		case "CLOSE_ALERTS": {
			const closedIds = action.alerts.map(a => a.id);
			const newState = Object.fromEntries(Object.entries(state).filter(([key]) => !closedIds.includes(key)));
			return newState;
		}

		case "RESTORE_ALERTS": {
			const newState = { ...state };
			action.alerts.forEach(alert => {
				if (alert) {
					newState[alert.id] = alert;
				}
			});
			return newState;
		}

		default:
			return state;
	}
};

const archiveItems = (state = [], action) => {
	switch (action.type) {
		case "GET_ALERT_ARCHIVE_SUCCESS": {
			const ids = action.alerts.map(item => item.id);
			return Array.from(new Set([...state, ...ids]));
		}
		case "REOPEN_ALERT": {
			const { alertId } = action;
			const newState = state.filter(id => id !== alertId);
			return newState;
		}
		case "DUMP_ALERT_ARCHIVE": {
			const newState = [];
			return newState;
		}

		default:
			return state;
	}
};

const archiveItemsById = (state = {}, action) => {
	switch (action.type) {
		case "GET_ALERT_ARCHIVE_SUCCESS": {
			const newState = { ...state };
			action.alerts.forEach(alert => {
				newState[alert.id] = state[alert.id] ? deepMerge({}, state[alert.id], alert) : alert;
			});
			return newState;
		}
		case "REOPEN_ALERT": {
			const { alertId } = action;
			const newState = { ...state };
			delete newState[alertId];
			return newState;
		}
		case "DUMP_ALERT_ARCHIVE": {
			const newState = {};
			return newState;
		}

		default:
			return state;
	}
};

export const initialState = {
	initial: false,
	activeItems: [],
	activeItemsById: {},
	archiveItems: [],
	archiveItemsById: {}
};

const alerts = (state = initialState, action) => {
	switch (action.type) {
		case "INITIAL_ALERTS_RECEIVED":
			return {
				...state,
				initial: true,
				activeItems: activeItems(state.activeItems, action),
				activeItemsById: activeItemsById(state.activeItemsById, action)
			};
		case "ALERT_BATCH_RECEIVED":
		case "CLOSE_ALERT":
		case "CLOSE_ALERTS":
		case "RESTORE_ALERTS":
			return {
				...state,
				initial: false,
				activeItems: activeItems(state.activeItems, action),
				activeItemsById: activeItemsById(state.activeItemsById, action)
			};
		case "DUMP_ALERT_ARCHIVE":
		case "GET_ALERT_ARCHIVE_SUCCESS":
		case "REOPEN_ALERT": {
			return {
				...state,
				archiveItems: archiveItems(state.archiveItems, action),
				archiveItemsById: archiveItemsById(state.archiveItemsById, action)
			};
		}
		default:
			return state;
	}
};

export default alerts;
